import React from 'react'
import styled from 'styled-components'
import SMConst from 'frontend_core/dist/constants/sm-const'

export default ({ paidForm, stateText, onClickBack, onClickRegister }) => {
  const {
    contactPersonFamilyName,
    contactPersonGivenName,
    contactPersonFamilyNameKana,
    contactPersonGivenNameKana,
    email,
    businessTaxId,
    corpName,
    corpNameKana,
    ceoFamilyName,
    ceoGivenName,
    ceoFamilyNameKana,
    ceoGivenNameKana,
    postalCode,
    city,
    address1,
    address2,
    tel,
    paymentMethod,
  } = paidForm

  return (
    <Wrapper>
      <div className="page__popup">
        <div className="page__popup-col1">
          <p className="page__popup__cancel search-change__cancel">
            <a
              href="#"
              onClick={e => {
                e.preventDefault()
                onClickBack()
              }}
            >
              <span className="page__popup__cancel-icon search-change__cancel-icon">
                ×
              </span>
            </a>
          </p>
          <div className="popup-headline">
            <h2 className="popup-headline__title">ご確認ください</h2>
            <p className="popup-headline__text">
              {paymentMethod === SMConst.PaymentMethod.Paid ? (
                <span>
                  下記の情報で審査申請をします。
                  <br />
                  情報に不備があった場合、再申請はPaidへお電話していただく必要がありますので
                  <br />
                </span>
              ) : (
                <span className="popup-headline__text">
                  下記の情報で保存します。
                  <br />
                </span>
              )}
              入力情報にお間違いがないよう、ご確認をお願いいたします。
            </p>
          </div>
          <h3 className="confirm-modal__subtitle">担当者情報</h3>
          <dl className="confirm-modal__list">
            <div>
              <dt>担当者氏名：</dt>
              <dd>
                {contactPersonFamilyName} {contactPersonGivenName}
              </dd>
            </div>
            <div>
              <dt>担当者氏名カナ：</dt>
              <dd>
                {contactPersonFamilyNameKana} {contactPersonGivenNameKana}
              </dd>
            </div>
            <div>
              <dt>担当者メールアドレス：</dt>
              <dd>{email}</dd>
            </div>
          </dl>
          <h3 className="confirm-modal__subtitle">会社情報</h3>
          <dl className="confirm-modal__list">
            <div>
              <dt>法人番号：</dt>
              <dd>{businessTaxId}</dd>
            </div>
            <div>
              <dt>会社名：</dt>
              <dd>{corpName}</dd>
            </div>
            <div>
              <dt>会社名カナ：</dt>
              <dd>{corpNameKana}</dd>
            </div>
            <div>
              <dt>代表者氏名：</dt>
              <dd>
                {ceoFamilyName} {ceoGivenName}
              </dd>
            </div>
            <div>
              <dt>代表者氏名カナ：</dt>
              <dd>
                {ceoFamilyNameKana} {ceoGivenNameKana}
              </dd>
            </div>
            <div>
              <dt>郵便番号：</dt>
              <dd>{postalCode}</dd>
            </div>
            <div>
              <dt>都道府県市町村：</dt>
              <dd>
                {stateText}
                {city}
              </dd>
            </div>
            <div>
              <dt>町名番地：</dt>
              <dd>{address1}</dd>
            </div>
            <div>
              <dt>ビル名・部屋番号：</dt>
              <dd>{address2}</dd>
            </div>
            <div>
              <dt>電話番号：</dt>
              <dd>{tel}</dd>
            </div>
          </dl>
          <h3 className="confirm-modal__subtitle">お支払い方法</h3>
          <dl className="confirm-modal__list">
            {paymentMethod === SMConst.PaymentMethod.Card && (
              <div>
                <dt>お支払い方法：</dt> <dd>クレジットカード</dd>
              </div>
            )}
            {paymentMethod === SMConst.PaymentMethod.Paid && (
              <div>
                <dt>お支払い方法：</dt> <dd>銀行振込（Paid）</dd>
              </div>
            )}
          </dl>
          {paymentMethod === SMConst.PaymentMethod.Card && (
            <div className="confirm-modal__button">
              <input
                type="button"
                name="commit"
                value="修正する"
                onClick={onClickBack}
                className="button-gray mr5 pt15 pb15 w200 sm-w100"
              />
              <input
                type="button"
                name="commit"
                value="保存する"
                onClick={onClickRegister}
                className="button-green mt10 mr5 pt15 pb15 w200 sm-w100"
              />
            </div>
          )}
          {paymentMethod === SMConst.PaymentMethod.Paid && (
            <div className="confirm-modal__button">
              <input
                type="button"
                name="commit"
                value="修正する"
                onClick={onClickBack}
                className="button-gray mr5 pt15 pb15 w200 sm-w100"
              />
              <input
                type="button"
                name="commit"
                value="審査申請する"
                onClick={onClickRegister}
                className="button-green mt10 mr5 pt15 pb15 w200 sm-w100"
              />
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  overflow-y: scroll;
`
